module.exports = __webpack_public_path__ + "media/images/flags/4x3/ben-c9649dbb226588701efc55e3a41fc59d.svg";